/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Charyung Kim (crkim@rsupport.com)
 *
 * @description
 *
 * @created at Mon Dec 09 2024
 **/

import { css } from "@emotion/react";

export const IndicatorWrapperStyle = css`
	position: absolute;
	left: -20px;
	width: 100%;

	&.offsetTop {
		top: -10px;
	}
`;

export const IndicatorStyle = css`
	position: absolute;
	visibility: hidden;
	pointer-events: none;
	left: 0;
	top: 0;
	z-index: 20;
`;

export const IconStyle = css`
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const UsernameWrapperStyle = css`
	position: relative;
	top: 10px;
	left: 25px;
`;

export const UsernameStyle = (color: string) => css`
	position: relative;
	z-index: 20;
	padding: 2px 8px;
	border-radius: 20px;
	background-color: #fff;
	color: ${color};
	font-size: 11px;
	font-weight: bold;
	box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12);
	white-space: nowrap;

	&::before {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: ${color};
		opacity: 0.1;
		border-radius: 20px;
		z-index: 0;
	}

	&.active {
		border: solid 1px ${color};
	}
`;
